import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import CustomerFeedback from "@/pages/CustomerFeedback";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/pages/AdminLayout";
import Dashboard from "@/pages/Dashboard";
import FeedbackList from "@/pages/FeedbackList";
import Customers from "@/pages/Customers";
import Outlets from "@/pages/Outlets";
import OutletSettings from "@/pages/OutletSettings";
import OutletQR from "@/pages/OutletQR";
import Users from "@/pages/Users";
import Coupons from "@/pages/Coupons";
import Redeem from "@/pages/Redeem";
import Landing from "@/pages/Landing";
import SubscriptionExpired from "@/pages/SubscriptionExpired";
import Subscriptions from "@/pages/Subscriptions";
import AccountSettings from "@/pages/AccountSettings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 text-sm text-zinc-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "outlet_admin" && user.subscription?.status === "EXPIRED") {
    return <SubscriptionExpired />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/f/:slug" element={<CustomerFeedback />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="feedback" element={<FeedbackList />} />
            <Route path="customers" element={<Customers />} />
            <Route path="outlets" element={<Outlets />} />
            <Route path="outlets/:id/settings" element={<OutletSettings />} />
            <Route path="outlets/:id/qr" element={<OutletQR />} />
            <Route path="users" element={<Users />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="account" element={<AccountSettings />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="redeem" element={<Redeem />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
